import * as React from 'react';

import { type TAvailableModifierActions } from '@/packages/Filters';
import { FDealType, isResidential as isResidentialFn } from '@/packages/JsonQuery';

import { PostfixPopupLink } from '../../../../../../components/Select';
import { useFiltersContext } from '../../../../../../utils/context';
import { useDealType } from '../../../../../../utils/useDealType';
import { useOfferType } from '../../../../../../utils/useOfferType';

import { useLink } from './hooks/useLink';

export const OfferTypePopupPostfix: React.FC = () => {
  const { onChange } = useFiltersContext();
  const dealType = useDealType();
  const offerType = useOfferType();
  const link = useLink();

  const isResidential = isResidentialFn(offerType);
  const action: TAvailableModifierActions = isResidential ? 'switchToCommercial' : 'switchToResidential';
  const text = isResidential ? 'Коммерческая' : 'Жилая';

  const handleClick = React.useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();

      onChange({ action, arguments: [] });
    },
    [action, onChange],
  );

  if (dealType === FDealType.RentDaily) {
    return null;
  }

  return <PostfixPopupLink href={link} text={text} onClick={handleClick} />;
};
